import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { toast } from 'sonner'

import { getSocket } from '@/api/socket'
import { useUser } from '@/domains/auth'

import { installBillingSocketHandlers } from './socket-handlers'

/* app-wide, not page-scoped: an invoice can be paid from anywhere and the plan
 * it unlocks gates the whole app. shares the socket singleton, so it detaches
 * its own listeners and never disconnects. */
export function useBillingBootstrap(): void {
  const queryClient = useQueryClient()
  const isSuper = useUser().user?.isSuper ?? false

  useEffect(() => {
    const detach = installBillingSocketHandlers(
      getSocket(),
      queryClient,
      payload => {
        /* the cache still refreshes: staff hold no plan of their own, so only
         * the "you're on X" claim is wrong, not the invalidation. */
        if (isSuper) return
        /* the broadcast fires on every subscription write, including a resume
         * and a cancel that take no money, so it cannot claim a payment. */
        toast.success(`Your plan is now ${payload.planLabel}.`)
      }
    )
    return () => {
      detach()
    }
  }, [queryClient, isSuper])
}
